/**
 * List of storyblock variables.
 */
export const VARIABLES = [
    ['--storyblock-background', { external: true }],
    ['--storyblock-border-radius', { external: true }],
];
